// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal-module__container___1nHxQ","close-btn":"Modal-module__close-btn___3HzvI"};